/**
 * calc.js
 *
 * Czysta logika obliczen kalkulatora kalorii DNZ.
 * Zadnego DOM, zadnego jQuery. Importowalne w Node (test regresji)
 * i w przegladarce (window.dnzKalk.oblicz).
 *
 * Blok obliczeniowy ponizej to DOSLOWNA kopia z testy/generuj-golden.js
 * (a ten z wp-content/themes/dnnz/assets/js/blocks/calories-calculator.js,
 * linie ~336-365). Nie refaktoryzowac, nie "poprawiac".
 *
 * weight / height / age przychodza jako STRINGI, dokladnie jak z .val()
 * w oryginale. JS rzutuje je w dzialaniach arytmetycznych.
 */

// ---------------------------------------------------------------------------
// BLOK OBLICZENIOWY - KOPIA 1:1 ZE STAREGO KODU. NIE MODYFIKOWAC.
// ---------------------------------------------------------------------------
function oblicz(sex, weightRaw, heightRaw, ageRaw, activity, trainings, goal) {
    // odwzorowanie preprocessingu z handlera submit:
    const weight = String(weightRaw).replace(',', '.');
    const height = String(heightRaw).replace(',', '.');
    const age = String(ageRaw);

    const pal_table = [
        [1.3, 1.4, 1.5, 1.6, 1.7],
        [1.4, 1.5, 1.6, 1.7, 1.8],
        [1.4, 1.5, 1.6, 1.7, 1.8],
        [1.5, 1.6, 1.7, 1.8, 1.9],
        [1.6, 1.7, 1.8, 1.9, 2.0],
        [1.7, 1.8, 1.9, 2.0, 2.1],
    ];

    const pal = pal_table[activity][trainings];
    const ppm = (sex === 'female') ? 10 * weight + 6.25 * height - 5 * age - 161 : 10 * weight + 6.25 * height - 5 * age + 5;
    const cpm = Math.round(ppm * pal + parseInt(goal));

    const multipliers = {
        proteins: 1.4,
        fats: 0.3
    }

    if (parseInt(goal) === 0) {
        multipliers.proteins = 1.2;
    }

    if (parseInt(goal) > 0) {
        multipliers.proteins = 1.6;
        multipliers.fats = 0.27;
    }

    const proteins = multipliers.proteins * weight;
    const fats = (cpm * multipliers.fats) / 9;
    const carbs = (cpm - (proteins * 4) - (fats * 9)) / 4;

    const low_cal_warning = (cpm <= 1500);

    // pola segmentacyjne CF7 - tez z oryginalu
    let age_text = '';
    if (age <= 24) { age_text = '1-24 lat'; }
    if (age >= 25 && age <= 34) { age_text = '25-34 lat'; }
    if (age >= 35) { age_text = '35-115 lat'; }

    let trainings_text = '';
    if (trainings <= 1) { trainings_text = 'mała'; }
    if (trainings >= 2) { trainings_text = 'duża'; }

    return {
        // wartosci WYSWIETLANE uzytkownikowi (po Math.round, jak w oryginale)
        cpm: Math.round(cpm),
        proteins: Math.round(proteins),
        fats: Math.round(fats),
        carbs: Math.round(carbs),
        low_cal_warning,
        // pola segmentacyjne
        seg_age: age_text,
        seg_trainings: trainings_text,
        // DNZ 2026-09-09 (decyzja Leszka): skladowe do rozkladu wyniku na ekranie.
        // Wylacznie wystawienie wartosci juz policzonych wyzej - zaden wzor sie nie zmienil.
        ppm: ppm,
        pal: pal,
    };
}
// ---------------------------------------------------------------------------
// KONIEC BLOKU KOPIOWANEGO
// ---------------------------------------------------------------------------

/**
 * Podział dziennych kalorii na posiłki (warstwa prezentacji, nie nowa kalkulacja).
 * 4 posiłki: 25/35/10/30. Poniżej 1500 kcal przekąska robi się zbyt mała,
 * więc 3 posiłki: 30/40/30. Różnica z zaokrągleń zawsze ląduje na obiedzie,
 * bo jest największy - korekta jest procentowo niewidoczna.
 *
 * Zgodnie ze specyfikacją "kalkulator-kalorii-ekran-wyniku", sekcja 4.
 */
function splitMeals(cpm) {
    const total = Math.round(cpm);
    const plan = total < 1500
        ? [{ name: 'Śniadanie', p: 0.30 }, { name: 'Obiad', p: 0.40 }, { name: 'Kolacja', p: 0.30 }]
        : [{ name: 'Śniadanie', p: 0.25 }, { name: 'Obiad', p: 0.35 }, { name: 'Przekąska', p: 0.10 }, { name: 'Kolacja', p: 0.30 }];

    const rows = plan.map(function (m) { return { name: m.name, kcal: Math.round(total * m.p) }; });
    const sum = rows.reduce(function (a, r) { return a + r.kcal; }, 0);
    const diff = total - sum;
    const lunchIndex = rows.findIndex(function (r) { return r.name === 'Obiad'; });
    rows[lunchIndex].kcal += diff;

    return rows;
}

if (typeof module !== 'undefined' && module.exports) {
    module.exports = { oblicz, splitMeals };
}
if (typeof window !== 'undefined') {
    window.dnzKalk = window.dnzKalk || {};
    window.dnzKalk.oblicz = oblicz;
    window.dnzKalk.splitMeals = splitMeals;
}
